// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"01058902","305":"e0659c76","493":"2bc811d0","494":"322aa75d","606":"1dd2f1ac","692":"a79f638e","755":"1b6e1af9","864":"198963f5"}[chunkId] + ".chunk.js";
};